module.exports = __webpack_public_path__ + "static/media/cloud_upload~bgWNTSVp.cf12b6e2.svg";